import { object, string } from "yup";

const validationSchema = object().shape({
  username: string()
    .email("Your Username must be a valid email")
    .required("You must enter your Username"),
});

export default () => validationSchema;
